import {
  Mention,
  MENTION_PATTERN,
  MentionType,
  TAG_PATTERN,
} from '@app/utils/mention'
import * as React from 'react'
import { Link } from 'react-router-dom'
import AutolinkerText from './AutolinkerText'

interface IMarkupTextProps {
  noLinks?: boolean
  text: string
  tag?: string
}

export default class MarkupText extends React.PureComponent<IMarkupTextProps> {
  public render() {
    const { noLinks, text, tag, ...props } = this.props

    if (!text) {
      return null
    }

    const matcher = new RegExp(`${MENTION_PATTERN}|${TAG_PATTERN}`, 'g')
    const children = []

    let lText = text
    let match = matcher.exec(lText)

    while (match != null) {
      // Add the text before the match to the children array
      children.push(
        this._renderText(
          `markup-${children.length}`,
          lText.substring(0, match.index),
        ),
      )

      const matchText = match.toString()

      if (matchText[0] === '@') {
        // Mention
        const mention = new Mention(matchText)
        children.push(
          this._renderMention(`mention-${children.length}`, mention),
        )
      } else {
        // Hashtag
        children.push(this._renderHashtag(`tag-${children.length}`, matchText))
      }

      lText = lText.substring(match.index + match[0].length)
      matcher.lastIndex = 0
      match = matcher.exec(lText)
    }

    if (lText.length > 0) {
      children.push(this._renderText(`markup-${children.length}`, lText))
    }

    return React.createElement(tag || 'div', props, children)
  }

  private _renderHashtag(key: string, text: string) {
    return this.props.noLinks === true ? (
      <span key={key}>{text}</span>
    ) : (
      <Link
        key={key}
        to={`/feed/search/?filter=${encodeURIComponent(text)}`}
        className='tag'
      >
        {text}
      </Link>
    )
  }

  private _renderMention(key: string, mention: Mention) {
    if (this.props.noLinks) {
      return <span key={key}>{mention.text}</span>
    }

    return mention.getMentionType() === MentionType.Staff ? (
      <span key={key} className={`mention-${mention.getMentionType()}`}>
        {mention.text}
      </span>
    ) : (
      <Link
        key={key}
        to={mention.getDetailUrl()}
        className={`mention-${mention.getMentionType()}`}
      >
        {mention.text}
      </Link>
    )
  }

  private _renderText(key: string, text: string) {
    return this.props.noLinks === true ? (
      <span key={key} dangerouslySetInnerHTML={{ __html: text }} />
    ) : (
      <AutolinkerText key={key} tag='span' text={text} />
    )
  }
}
